<template>
  <div class="accum" :class="cssType">
    <Banner />
    <AppLang class="app-lang" type="accum" />
    <ValidateUser style="z-index: 3;" />
    <Rewards :style="{ zIndex: state.dialogOpen > 0 ? 1000 : 2 }" @dialogOpen="handleDialogOpen" />
    <Rule style="z-index: 2;" />
    <AppFooter />
    <ActFloat v-if="state.dialogOpen <= 0" />
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import Banner from './components/Banner'
import AppLang from '@/components/AppLang'
import ValidateUser from '@/components/ValidateUser/ActAccum'
import Rewards from './components/Rewards'
import Rule from './components/Rule'
import AppFooter from '@/components/AppFooter'
import ActFloat from './components/ActFloat'
import { useLog } from '@/composables/useLog'
import { isMobile } from '@/utils'
const log = useLog()
log.track('act_accum_page_entry', {
  referrer: document.referrer
})
const cssType = isMobile ? 'mobile' : 'pc'
const state = reactive({
  dialogOpen: 0
})
const handleDialogOpen = (visible) => {
  state.dialogOpen = visible ? state.dialogOpen + 1 : state.dialogOpen - 1
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>